export default __webpack_public_path__ + "77da91a0f541b4ce37d87005e2d2b726.svg";